import React from "react";
import DetailPickerContainer from "pages/detailPicker/DetailPickerContainer";
import PickersContainer from "pages/pickers/PickersContainer";
import { Route, Switch, Redirect, useLocation } from "react-router"; // react-router v4/v5
import DashboardContainer from "../pages/dashboard/DashboardAdminContainer";
import Transaction from "../pages/transaction/TransactionContainer";
import WrapperPreliquidationContainer from "pages/detailPreliquidation/WrapperPreliquidationContainer";
import Polygons from "pages/polygons/PolygonsContainer";
import Slots from "pages/slots/SlotsContainer";
import PreliquidationContainer from "pages/preliquidation/PreliquidationContainer";
import TermsAndConditionsContainer from "pages/termsAndConditions/TermsAndConditionsContainer";
import GovernmentalEntityContainer from "pages/governmentalEntity/GovernmentalEntityContainer";
import "../App.css";
import PageLoader from "component/PageLoader/PageLoader";
import { getValue } from "utils/utils";
import { CountryCodeType } from "@pickit/pickit-components";
import Header from "component/Header/Header";
import Home from "pages/home/Home";
import DeliveryEvidenceContainer from "pages/transaction/deliveryEvidence/DeliveryEvidenceContainer";

const PrivateRoutes = (): JSX.Element => {
  const tokens = getValue("tokens", true);
  const { pathname } = useLocation();
  const [, params] = pathname?.split("/") as [
    undefined,
    CountryCodeType,
    string
  ];
  const countryCodeURL = params.toUpperCase();
  const hasToken = countryCodeURL in tokens;

  const isDeliveryEvidence = pathname?.includes("/transaction/delivery-evidence");

  return !hasToken ? (
    <Redirect to="/login" />
  ) : isDeliveryEvidence ? (
    <Switch>
      <Route
        path="/:countryCode/transaction/delivery-evidence"
        exact
        component={DeliveryEvidenceContainer}
      />
      <Redirect from="*" to="/login" />
    </Switch>
  ) : (
    <div className="app-container">
      <Header />

      <PageLoader />
      <div className="page-content">
        <Switch>
          <Route path="/:countryCode/" exact component={Home} />
          <Route
            path="/:countryCode/dashboard"
            exact
            component={DashboardContainer}
          />
          <Route
            path="/:countryCode/pickers"
            exact
            component={PickersContainer}
          />
          <Route
            path="/:countryCode/pickers/detail/:id"
            exact
            component={DetailPickerContainer}
          />
          <Route
            path="/:countryCode/transaction/delivery-evidence"
            exact
            component={DeliveryEvidenceContainer}
          />
          <Route
            path="/:countryCode/transaction"
            exact
            component={Transaction}
          />
          <Route path="/:countryCode/polygons" exact component={Polygons} />
          <Route path="/:countryCode/slots" exact component={Slots} />
          <Route
            path="/:countryCode/terms-and-conditions"
            exact
            component={TermsAndConditionsContainer}
          />
          <Route
            path="/:countryCode/governmental-entity"
            exact
            component={GovernmentalEntityContainer}
          />
          <Route
            path="/:countryCode/presettlements"
            exact
            component={PreliquidationContainer}
          />
          <Route
            path="/:countryCode/presettlements/detail/:id"
            exact
            component={WrapperPreliquidationContainer}
          />
          <Redirect from="*" to="/login" />
        </Switch>
      </div>
    </div>
  );
};

export default PrivateRoutes;
